import React, { useEffect, useState } from "react";
import AgeInputField from "../AgeInputField";
import "./agePickerComponent.scss";

const AgePickerComponent = (props) => {
  const { value, disabled, updateOnGet, handleOnChangeInput } = props;
  const [patinetAge, setPatientAge] = useState({
    years: "00",
    months: "00",
    days: "00",
    yearsDropdown: false,
    monthsDropdown: false,
    daysDropdown: false,
  });

  useEffect(() => {
    if (value && updateOnGet) {
      let year = value?.split("years");
      let month = year[1]?.split("months");
      let day = month[1]?.split("days");
      let yy = year && Number(year[0]?.trim());
      let mm = month && Number(month[0]?.trim());
      let dd = day && Number(day[0]?.trim());

      setPatientAge({
        ...patinetAge,
        years: yy <= 9 ? "0" + yy : yy,
        months: mm <= 9 ? "0" + mm : mm,
        days: dd <= 9 ? "0" + dd : dd,
      });
    }
  }, [value, updateOnGet]);

  const generateList = (start, end) => {
    const lists = [];

    for (let i = start; i <= end; i++) {
      if (i < 10) {
        lists.push("0" + i);
      } else {
        lists.push(i);
      }
    }
    return lists;
  };

  const renderDropDown = (type) => {
    if (type === "years") {
      return generateList(0, 110); //100
    } else if (type === "months") {
      return generateList(0, 12); //11
    } else if (type === "days") {
      return generateList(0, 31);
    }
  };

  const handlePatientDropdown = (name) => {
    if (name === "years") {
      setPatientAge({
        ...patinetAge,
        yearsDropdown: !patinetAge.yearsDropdown,
        monthsDropdown: false,
        daysDropdown: false,
      });
    } else if (name === "months") {
      setPatientAge({
        ...patinetAge,
        yearsDropdown: false,
        monthsDropdown: !patinetAge.monthsDropdown,
        daysDropdown: false,
      });
    } else if (name === "days") {
      setPatientAge({
        ...patinetAge,
        yearsDropdown: false,
        monthsDropdown: false,
        daysDropdown: !patinetAge.daysDropdown,
      });
    }
  };

  const handleInputChange = (e, name) => {
    const inputDataValue = e.target.value;
    if (!Number.isNaN(+inputDataValue)) {
      if (name === "days" || name === "months") {
        if (inputDataValue.length < 2) {
          setPatientAge({
            ...patinetAge,
            [name]: inputDataValue,
            [name + "Dropdown"]: false,
          });
        } else if (
          inputDataValue.length == 2 &&
          name === "days" &&
          +inputDataValue > 0 &&
          +inputDataValue <= 31
        ) {
          setPatientAge({
            ...patinetAge,
            [name]: inputDataValue,
            [name + "Dropdown"]: false,
          });
        } else if (
          inputDataValue.length == 2 &&
          name === "months" &&
          +inputDataValue > 0 &&
          +inputDataValue <= 12
        ) {
          setPatientAge({
            ...patinetAge,
            [name]: inputDataValue,
            [name + "DropDown"]: false,
          });
        } else {
          setPatientAge({ ...patinetAge, [name + "Dropdown"]: false });
        }
      } else if (name === "years") {
        if (
          inputDataValue.length <= 3 &&
          +inputDataValue >= 0 &&
          +inputDataValue <= 110
        ) {
          setPatientAge({
            ...patinetAge,
            days:
              patinetAge.days <= 9 && patinetAge.days.length == 1
                ? "0" + patinetAge.days
                : patinetAge.days,
            months:
              patinetAge.months <= 9 && patinetAge.months.length == 1
                ? "0" + patinetAge.months
                : patinetAge.months,
            [name]: inputDataValue,
            [name + "Dropdown"]: false,
          });
        } else {
          setPatientAge({
            ...patinetAge,
            [name + "Dropdown"]: false,
          });
        }
      }

      combineYyMmDD(name, inputDataValue);
    }
  };

  const handleSelect = (name, data) => {
    setPatientAge({ ...patinetAge, [name]: data, [name + "Dropdown"]: false });
    combineYyMmDD(name, data);
  };

  const handleBlockInvalidChar = (e) => {
    ["e", "E", "-", "+"].includes(e.key) && e.preventDefault();
  };

  const operationHandler = (name, inputValue) => {
    let newVal = "";
    if (name === "days") {
      const days = new Date(patinetAge.years, patinetAge.months, 0).getDate();
      if (patinetAge[name] >= days && inputValue > 0) {
        setPatientAge({
          ...patinetAge,
          [name]: days,
          [name + "Dropdown"]: false,
        });
        newVal = days;
      } else if (+patinetAge[name] <= 1 && inputValue < 0) {
        setPatientAge({
          ...patinetAge,
          [name]: "00",
          [name + "Dropdown"]: false,
        });
        newVal = "00";
      } else {
        if (
          (patinetAge[name] < 9 && inputValue > 0) ||
          (patinetAge[name] <= 10 && inputValue < 0)
        ) {
          setPatientAge({
            ...patinetAge,
            [name]: "0" + (+patinetAge[name] + inputValue),
            [name + "Dropdown"]: false,
          });
          newVal = "0" + (+patinetAge[name] + inputValue);
        } else {
          setPatientAge({
            ...patinetAge,
            [name]: +patinetAge[name] + inputValue,
            [name + "Dropdown"]: false,
          });
          newVal = +patinetAge[name] + inputValue;
        }
      }
    } else if (name === "months") {
      if (+patinetAge[name] >= 12 && inputValue > 0) {
        setPatientAge({
          ...patinetAge,
          [name]: 12,
          [name + "Dropdown"]: false,
        });
        newVal = 12;
      } else if (+patinetAge[name] <= 1 && inputValue < 0) {
        setPatientAge({
          ...patinetAge,
          [name]: "00",
          [name + "Dropdown"]: false,
        });
        newVal = "00";
      } else if (+patinetAge[name] == 0 && inputValue > 0) {
        setPatientAge({
          ...patinetAge,
          [name]: "01",
          [name + "Dropdown"]: false,
        });
        newVal = "01";
      } else {
        if (+patinetAge[name] < 9 && +patinetAge[name] >= 1 && inputValue > 0) {
          setPatientAge({
            ...patinetAge,
            [name]: "0" + (+patinetAge[name] + inputValue),
            [name + "Dropdown"]: false,
          });
          newVal = "0" + (+patinetAge[name] + inputValue);
        } else if (
          +patinetAge[name] <= 10 &&
          +patinetAge[name] >= 1 &&
          inputValue < 0
        ) {
          setPatientAge({
            ...patinetAge,
            [name]: "0" + (+patinetAge[name] + inputValue),
            [name + "Dropdown"]: false,
          });
          newVal = "0" + (+patinetAge[name] + inputValue);
        } else {
          setPatientAge({
            ...patinetAge,
            [name]: +patinetAge[name] + inputValue,
            [name + "Dropdown"]: false,
          });
          newVal = +patinetAge[name] + inputValue;
        }
      }
    } else if (name === "years") {
      if (+patinetAge[name] >= 110 && inputValue > 0) {
        //100
        setPatientAge({
          ...patinetAge,
          [name]: "110",
          [name + "Dropdown"]: false,
        });
        newVal = "110";
      } else if (+patinetAge[name] <= 1 && inputValue < 0) {
        setPatientAge({
          ...patinetAge,
          [name]: "00",
          [name + "Dropdown"]: false,
        });
        newVal = "00";
      } else if (+patinetAge[name] == 0 && inputValue > 0) {
        setPatientAge({
          ...patinetAge,
          [name]: "01",
          [name + "Dropdown"]: false,
        });
        newVal = "01";
      } else {
        if (+patinetAge[name] < 9 && +patinetAge[name] >= 1 && inputValue > 0) {
          setPatientAge({
            ...patinetAge,
            [name]: "0" + (+patinetAge[name] + inputValue),
            [name + "Dropdown"]: false,
          });
          newVal = "0" + (+patinetAge[name] + inputValue);
        } else if (
          +patinetAge[name] <= 10 &&
          +patinetAge[name] >= 1 &&
          inputValue < 0
        ) {
          setPatientAge({
            ...patinetAge,
            [name]: "0" + (+patinetAge[name] + inputValue),
            [name + "Dropdown"]: false,
          });
          newVal = "0" + (+patinetAge[name] + inputValue);
        } else {
          setPatientAge({
            ...patinetAge,
            [name]: +patinetAge[name] + inputValue,
            [name + "Dropdown"]: false,
          });
          newVal = +patinetAge[name] + inputValue;
        }
      }
    }
    combineYyMmDD(name, newVal);
  };

  const combineYyMmDD = (name, val = "00") => {
    let data = "";
    if (name === "years") {
      data =
        val +
        " years " +
        patinetAge?.months +
        " months " +
        patinetAge?.days +
        " days";
    } else if (name === "months") {
      data =
        patinetAge?.years +
        " years " +
        val +
        " months " +
        patinetAge?.days +
        " days";
    } else if (name === "days") {
      data =
        patinetAge?.years +
        " years " +
        patinetAge?.months +
        " months " +
        val +
        " days";
    }

    handleOnChangeInput(data);
  };

  return (
    <div className="">
      <div className="age_picker_label">Age</div>
      <div className={`d-flex  ${disabled && "disable_age_picker"}`}>
        <div className="age_input_div">
          <AgeInputField
            name="years"
            value={patinetAge?.years}
            bottomLabel={"Years"}
            showDropdown={patinetAge?.yearsDropdown}
            dropdownList={renderDropDown("years")}
            handleShowDropdown={() => handlePatientDropdown("years")}
            handleInputChange={(e) => handleInputChange(e, "years")}
            handleBlockInvalidChar={handleBlockInvalidChar}
            handleSelect={handleSelect}
            operationHandler={operationHandler}
            disabled={disabled}
          />
        </div>
        <div className="age_input_div mx-2">
          <AgeInputField
            name="months"
            value={patinetAge?.months}
            bottomLabel={"Months"}
            showDropdown={patinetAge?.monthsDropdown}
            dropdownList={renderDropDown("months")}
            handleShowDropdown={() => handlePatientDropdown("months")}
            handleInputChange={(e) => handleInputChange(e, "months")}
            handleBlockInvalidChar={handleBlockInvalidChar}
            handleSelect={handleSelect}
            operationHandler={operationHandler}
            disabled={disabled}
          />
        </div>
        <div className="age_input_div">
          <AgeInputField
            name="days"
            value={patinetAge?.days}
            bottomLabel={"Days"}
            showDropdown={patinetAge?.daysDropdown}
            dropdownList={renderDropDown("days")}
            handleShowDropdown={() => handlePatientDropdown("days")}
            handleInputChange={(e) => handleInputChange(e, "days")}
            handleBlockInvalidChar={handleBlockInvalidChar}
            handleSelect={handleSelect}
            operationHandler={operationHandler}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default AgePickerComponent;
